import { useState } from "react";
import triniImg from "../assets/img/trini_logo_horizontal.svg";
import triniIcon from "../assets/img/LOGO_TRINI_CHATBOT.svg";
import { Link } from "react-router-dom";
import { logout } from "../services/auth";
import { Dropdown } from "primereact/dropdown";
import { useEffect } from "react";
import {
  BiHomeAlt,
  BiCog,
  BiChip,
  BiLineChart,
  BiMessageDots,
  BiBot,
  BiSitemap,
  BiConversation,
  BiChevronRight,
  BiMenu,
  BiX,
} from "react-icons/bi";
import { PiTreeStructureFill } from "react-icons/pi";
import { TiContacts } from "react-icons/ti";
import UserPanel from "./info/UserPanel";
import { BsMoon, BsPersonGear } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import { BsPuzzle } from "react-icons/bs";
import { RiMailSendLine } from "react-icons/ri";
import { TbReportMoney } from "react-icons/tb";
import { TbBrandOpenai } from "react-icons/tb";
import useChatbotConfig from "../hooks/useChatbotConfig";
import { PiFiles } from "react-icons/pi";

const Sidebar = (props) => {
  const { deleteToken, bots, hasBots, botId, botPermissions, botPlan } =
    useChatbotConfig();
  const [bot, setBot] = useState([]);
  const {
    toggleDarkMode,
    handletoggleDarkMode,
    handletoggleResponsive,
    toggleResponsive,
    toggle,
    setToggleResponsive,
    handletoggle,
    changeBot,
  } = props;

  useEffect(() => {
    setToggleResponsive(false);
    if (!isNaN(botId)) setBot(botId);
  }, [botId, bots, setToggleResponsive]);

  const handleLogout = () => {
    logout();
    deleteToken();
  };

  const botOptionTemplate = (option) => {
    return (
      <div className="bot-item">
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedbotTemplate = (option) => {
    return (
      <div className="d-flex align-items-center text-ellipsis">
        <BiBot className="icon" />
        {option && option?.length !== 0 ? (
          <span className="textSelect text-ellipsis" title={option.name}>
            {option.name}
          </span>
        ) : (
          <span className="textSelect">Sin Chatbot</span>
        )}
      </div>
    );
  };

  return (
    <>
      <nav className={toggle ? "sidebar" : "sidebar close"}>
        <header>
          <Link
            to="/home"
            className={toggle ? "text logo-text" : "text logo-text open"}
          >
            <img src={triniImg} style={{ height: "100%" }} alt="trini logo" />
          </Link>
          <Link to="/home" className={toggle ? "icon-close" : "icon"}>
            <img src={triniIcon} alt="" style={{ height: "100%" }} />
          </Link>
          <BiChevronRight onClick={handletoggle} className="toggle" />

          {!toggleResponsive ? (
            <BiMenu
              className="responsive-toggle"
              onClick={handletoggleResponsive}
            />
          ) : (
            <BiX
              className="responsive-toggle"
              onClick={handletoggleResponsive}
            />
          )}
        </header>

        <div
          className={
            !toggleResponsive ? "menu-bar" : "menu-bar open-responsive"
          }
        >
          <div className="menu">
            <div className={toggle ? "select-bot" : "select-bot close"}>
              {bots && (
                <Dropdown
                  value={bot}
                  options={bots}
                  optionValue="id"
                  optionLabel="img"
                  onChange={(e) => {
                    setBot(e.value);
                    changeBot(e.value);
                  }}
                  placeholder="Seleccionar Chatbot"
                  valueTemplate={selectedbotTemplate}
                  itemTemplate={botOptionTemplate}
                  appendTo="self"
                />
              )}
            </div>
            <ul className="menu-links">
              <li className="nav-link">
                <Link onClick={() => setToggleResponsive(false)} to="/home">
                  <BiHomeAlt className="icon" />
                  <span className="text nav-text">Inicio</span>
                </Link>
              </li>
              {hasBots && (
                <>
                  {botPermissions?.chats && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/chats"
                      >
                        <BiMessageDots className="icon" />
                        <span className="text nav-text">Conversaciones</span>
                      </Link>
                    </li>
                  )}
                  {botPermissions?.contacts && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/contacts"
                      >
                        <TiContacts className="icon" />
                        <span className="text nav-text">Agenda</span>
                      </Link>
                    </li>
                  )}

                  {botPermissions?.advanced_configuration && botPermissions?.campaigns && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/campaign"
                      >
                        <RiMailSendLine className="icon" />
                        <span className="text nav-text">Difusiones</span>
                      </Link>
                    </li>
                  )}

                  {(!botPlan?.ai_model && botPermissions?.responses) && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/responses/quick"
                      >
                        <BiConversation className="icon" />
                        <span className="text nav-text">Respuestas</span>
                      </Link>
                    </li>
                  )}

                  {(botPlan?.ai_model && botPermissions?.responses) && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/responses"
                      >
                        <BiConversation className="icon" />
                        <span className="text nav-text">Respuestas</span>
                      </Link>
                    </li>
                  )}

                  {botPermissions?.forms && (
                    <>
                      {!botPermissions?.only_contact_form ? (
                        <>
                          <li className="nav-link">
                            <Link
                              onClick={() => setToggleResponsive(false)}
                              to="/forms"
                            >
                              <BiSitemap className="icon" />
                              <span className="text nav-text">Formularios</span>
                            </Link>
                          </li>
                          <li className="nav-link">
                            <Link
                              onClick={() => setToggleResponsive(false)}
                              to="/forms/schemas"
                            >
                              <PiTreeStructureFill className="icon" />
                              <span className="text nav-text">Flujos</span>
                              <div className="ms-2">
                                <span
                                  style={{
                                    backgroundColor: "#e9f3ff",
                                    color: "#0b5cab",
                                    border: "1px solid #b6dcff",
                                    fontSize: "0.7rem",
                                    fontWeight: 700,
                                    borderRadius: "999px",
                                    padding: "0.18rem 0.5rem",
                                    lineHeight: "1.1",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  BETA
                                </span>
                              </div>
                            </Link>
                          </li>
                        </>

                      ) : (
                        <li className="nav-link">
                          <Link
                            onClick={() => setToggleResponsive(false)}
                            to="/forms/contact"
                          >
                            <BiSitemap className="icon" />
                            <span className="text nav-text">Formulario</span>
                          </Link>
                        </li>
                      )}
                    </>
                  )}

                  <li className="nav-link">
                    <Link
                      onClick={() => setToggleResponsive(false)}
                      to="/testbot"
                    >
                      <BiBot className="icon" />
                      <span className="text nav-text">Probá tu Chatbot</span>
                    </Link>
                  </li>
                  <li className="nav-link">
                    <Link
                      onClick={() => setToggleResponsive(false)}
                      to="/analytics"
                    >
                      <BiLineChart className="icon" />
                      <span className="text nav-text">Analíticas</span>
                    </Link>
                  </li>
                  {botPermissions?.pricing && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/billings"
                      >
                        <TbReportMoney className="icon" />
                        <span className="text nav-text">Facturación</span>
                      </Link>
                    </li>
                  )}
                  {botPermissions?.plugins && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/plugins"
                      >
                        <BsPuzzle className="icon" />
                        <span className="text nav-text">Conectores</span>
                      </Link>
                    </li>
                  )}
                  {botPermissions?.plugins && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/assistants"
                      >
                        <TbBrandOpenai className="icon" />
                        <span className="text nav-text">Asistentes</span>
                      </Link>
                    </li>
                  )}

                  <li className="nav-link">
                    <Link
                      onClick={() => setToggleResponsive(false)}
                      to="/storage"
                    >
                      <PiFiles className="icon" />
                      <span className="text nav-text">Almacenamiento</span>
                    </Link>
                  </li>
                  {(botPermissions?.advanced_configuration && botPlan?.ai_model) && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/advanced/examples"
                      >
                        <BiChip className="icon" />
                        <span className="text nav-text">Avanzado</span>
                      </Link>
                    </li>
                  )}

                  {(botPermissions?.advanced_configuration && !botPlan?.ai_model) && (
                    <li className="nav-link">
                      <Link
                        onClick={() => setToggleResponsive(false)}
                        to="/advanced/entities"
                      >
                        <BiChip className="icon" />
                        <span className="text nav-text">Avanzado</span>
                      </Link>
                    </li>
                  )}

                </>
              )}
            </ul>
          </div>

          <div className="bottom-content mb-3">
            {hasBots && botPermissions?.configuration && (
              <li className="bottom-nav-link">
                <Link
                  onClick={() => setToggleResponsive(false)}
                  to="/settings/general"
                >
                  <BiCog className="icon" />
                  <span className="text nav-text">Configuración</span>
                </Link>
              </li>
            )}
            <li className="menu-logout">
              <button type="button" onClick={handletoggleDarkMode}>
                <BsMoon className="icon" />
                <span className="text nav-text">
                  {toggleDarkMode
                    ? "Desactivar Tema Oscuro"
                    : "Activar Tema Oscuro"}
                </span>
              </button>
            </li>
            <li className="menu-logout">
              <Link
                onClick={() => setToggleResponsive(false)}
                to="/settings/user"
              >
                <BsPersonGear className="icon" />
                <span className="text nav-text">Editar Usuario</span>
              </Link>
            </li>
            <li className="menu-logout">
              <button type="button" onClick={handleLogout}>
                <FiLogOut className="icon" />
                <span className="text nav-text">Cerrar Sesión</span>
              </button>
            </li>
          </div>
        </div>
        <UserPanel
          toggleResponsive={toggleResponsive}
          logout={handleLogout}
          toggleDarkMode={toggleDarkMode}
          handletoggleDarkMode={handletoggleDarkMode}
        />
      </nav>
    </>
  );
};

export default Sidebar;
